export default "__VITE_ASSET__CdPqJiYG__"